// @flow
type TDialogBlock = {
    name?: string,
};

type TDialogBlockState = {
    data: TDialogBlock,
};
const initialState: TDialogBlockState = {
    data: {},
};

type TSetDialogBlock = {payload: TDialogBlock, type: 'SET_DIALOG_BLOCK'};

type TDialogBlockActionList = TSetDialogBlock;

function dialogBlockReducer(state: TDialogBlockState = initialState, {type, payload}: TDialogBlockActionList) {
    switch (type) {
        case 'SET_DIALOG_BLOCK':
            return {
                ...state,
                data: payload,
            };
        case 'SET_NOT_FINISH_DIALOG':
            return {
                ...state,
                isFinishDialog: false,
            };
        case 'SET_FINISH_DIALOG':
            return {
                ...state,
                isFinishDialog: true,
            };
        default:
            return state;
    }
}

export {dialogBlockReducer};
export type {TDialogBlock, TSetDialogBlock, TDialogBlockState};
